import { useMutation, useQueryClient } from "react-query";
import { PagarContaForm } from "../typings";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function usePagarConta() {
  const queryClient = useQueryClient();
  return useMutation(
    (data: PagarContaForm) => {
      return http.post(`/v1/conta/${data.id}/pagar`, data);
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: ({ queryKey }) =>
            typeof queryKey === "string" && queryKey.startsWith("/v1/conta"),
        });
      },
    }
  );
}

export default usePagarConta;
